const Styles = {
    mainWrapper: {
        background: '#FBFCFE 0% 0% no-repeat padding-box',
        boxShadow: 'rgba(0, 92, 188, 0.15) 0px 0px 24px 0',
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0',
        height: '68px',
    },
    subWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
    ImgSpan: { display: 'flex', alignItems: 'center' },
    img: { width: '33.43px', height: '33.43px' },
    keyvaultimg: { width: '53.43px', height: '33.43px' },
    title: {
        pl: 2,
        color: (theme) => theme?.palette?.black?.dark,
        fontSize: '20px',
        fontWeight: 'medium',
        fontFamily: 'Roboto',
    },
    infoIconStyle: { marginLeft: 1, marginTop: 1 },
    buttonWrapper: {
        mr: '53px',
    },
    backBtn: { marginLeft: '-20px' },
    backIcon: { color: (theme) => theme.palette.blue.main },
};
export default Styles;
